// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* The switch - the box around the slider */
.switch {
    position: relative;
    display: block;
    height: 100%;
    aspect-ratio: 1.8;
    -webkit-tap-highlight-color: transparent;
  }
  
  /* Hide default HTML checkbox */
  .switch input {
    opacity: 0;
    width: 0;
    height: 0;
  }
  
  /* The slider */
  .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    -webkit-transition: .4s;
    transition: .4s;
  }
  
  .slider:before {
    position: absolute;
    content: "";
    height: 80%;
    aspect-ratio: 1.0;
    margin-top: 5%;
    background-color: white;
    -webkit-transition: .4s;
    transition: .4s;
  }
  
  input:checked + .slider {
    background-color: var(--selection-blue);
  }
  
  input:focus + .slider {
    box-shadow: 0 0 1px var(--selection-blue);
  }
  
  input:checked + .slider:before {
    -webkit-transform: translateX(112.5%);
    -ms-transform: translateX(112.5%);
    transform: translateX(112.5%);
  }

  input:not(:checked) + .slider:before {
    -webkit-transform: translateX(12.5%);
    -ms-transform: translateX(12.5%);
    transform: translateX(12.5%);
  }
  
  /* Rounded sliders */
  .slider.round {
    border-radius: 34px;
  }
  
  .slider.round:before {
    border-radius: 50%;
  }`, "",{"version":3,"sources":["webpack://./src/Switch.css"],"names":[],"mappings":"AAAA,2CAA2C;AAC3C;IACI,kBAAkB;IAClB,cAAc;IACd,YAAY;IACZ,iBAAiB;IACjB,wCAAwC;EAC1C;;EAEA,+BAA+B;EAC/B;IACE,UAAU;IACV,QAAQ;IACR,SAAS;EACX;;EAEA,eAAe;EACf;IACE,kBAAkB;IAClB,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,sBAAsB;IACtB,uBAAuB;IACvB,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,iBAAiB;IACjB,cAAc;IACd,uBAAuB;IACvB,uBAAuB;IACvB,eAAe;EACjB;;EAEA;IACE,uCAAuC;EACzC;;EAEA;IACE,yCAAyC;EAC3C;;EAEA;IACE,qCAAqC;IACrC,iCAAiC;IACjC,6BAA6B;EAC/B;;EAEA;IACE,oCAAoC;IACpC,gCAAgC;IAChC,4BAA4B;EAC9B;;EAEA,oBAAoB;EACpB;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB","sourcesContent":["/* The switch - the box around the slider */\n.switch {\n    position: relative;\n    display: block;\n    height: 100%;\n    aspect-ratio: 1.8;\n    -webkit-tap-highlight-color: transparent;\n  }\n  \n  /* Hide default HTML checkbox */\n  .switch input {\n    opacity: 0;\n    width: 0;\n    height: 0;\n  }\n  \n  /* The slider */\n  .slider {\n    position: absolute;\n    cursor: pointer;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: #ccc;\n    -webkit-transition: .4s;\n    transition: .4s;\n  }\n  \n  .slider:before {\n    position: absolute;\n    content: \"\";\n    height: 80%;\n    aspect-ratio: 1.0;\n    margin-top: 5%;\n    background-color: white;\n    -webkit-transition: .4s;\n    transition: .4s;\n  }\n  \n  input:checked + .slider {\n    background-color: var(--selection-blue);\n  }\n  \n  input:focus + .slider {\n    box-shadow: 0 0 1px var(--selection-blue);\n  }\n  \n  input:checked + .slider:before {\n    -webkit-transform: translateX(112.5%);\n    -ms-transform: translateX(112.5%);\n    transform: translateX(112.5%);\n  }\n\n  input:not(:checked) + .slider:before {\n    -webkit-transform: translateX(12.5%);\n    -ms-transform: translateX(12.5%);\n    transform: translateX(12.5%);\n  }\n  \n  /* Rounded sliders */\n  .slider.round {\n    border-radius: 34px;\n  }\n  \n  .slider.round:before {\n    border-radius: 50%;\n  }"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
